module.exports = __webpack_public_path__ + "img/Vector_nav_diagram.91810c0e.svg";